import { render, staticRenderFns } from "./InteractiveMatrix.vue?vue&type=template&id=980e9982"
import script from "./InteractiveMatrix.vue?vue&type=script&lang=js"
export * from "./InteractiveMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports